export default function selectVal(func) {
  return function(opt) {
    func(opt?.value);
  };
}
